var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWeatherFunnel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.52 13.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #667085;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.87,
    y1: 0.5,
    x2: 13.02,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.46,
    y1: 2.03,
    x2: 11.57,
    y2: 2.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 3.56,
    x2: 9.32,
    y2: 3.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.28,
    y1: 5.09,
    x2: 7.85,
    y2: 5.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.12,
    y1: 6.62,
    x2: 7.7,
    y2: 6.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.91,
    y1: 8.15,
    x2: 8.11,
    y2: 8.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.47,
    y1: 9.68,
    x2: 8.92,
    y2: 9.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.52,
    y1: 11.21,
    x2: 9.19,
    y2: 11.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.07,
    y1: 12.74,
    x2: 7.98,
    y2: 12.74
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherFunnel);
export default __webpack_public_path__ + "static/media/icon_weather_funnel.7fcdb99cde82337c821aca198dc4409f.svg";
export { ForwardRef as ReactComponent };